import React from "react";
import { Button, Grid, Typography } from "@mui/material";
import "../../assets/css/icon.css";

const ModalConferma = ({
  onClose,
  confirm,
  title,
  descriptionOne,
  descriptionTwo,
  copyButton,
  tag,
}) => {
  return (
    <Grid
      container
      item
      xs={11}
      md={5}
      sx={{
        borderRadius: "16px",
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "#fff",
        maxHeight: "100%",
        width: { xs: "90%", sm: "80%" },
      }}
    >
      <Grid
        item
        xs={12}
        style={{
          height: "60px",
          width: "100%",
          display: "flex",
          alignItems: "center",
          borderBottom: "1px solid #c6c6c6",
          padding: "0 15px",
          gap: "10px",
        }}
      >
        <div style={{ flexShrink: 0 }}>
          {tag === "delete" ? (
            <div className="icon-delete-aml-modal" />
          ) : tag === "otp" ? (
            <div className="icon-generate-otp-modal" />
          ) : tag === "approved" ? (
            <div className="icon-approved-aml-modal" />
          ) : tag === "expired" ? (
            <div className="icon-restar-aml-expired-modal" />
          ) : (
            <div className="icon-modal-info" />
          )}
        </div>
        <Typography
          className="color-blue-dark"
          style={{ flex: 1, minWidth: 0, fontSize: "18px", fontWeight: 600 }}
        >
          {title}
        </Typography>
        <div style={{ flexShrink: 0 }}>
          <div onClick={onClose} className="icon-modal-close" />
        </div>
      </Grid>

      <Grid
        item
        xs={12}
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          style={{
            padding: "10px 15px 0px 15px",
            marginTop: "20px",
          }}
          className="color-blue-dark"
        >
          {descriptionOne}
        </Typography>
        <Typography
          style={{
            padding: "0px 15px",
          }}
          className="color-blue-dark"
        >
          {descriptionTwo}
        </Typography>
      </Grid>

      <Grid container item xs={12} style={{ marginTop: "20px" }}>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "20px",
          }}
        >
          <Button
            sx={{ width: "140px" }}
            className="button-bg-purple"
            onClick={confirm}
          >
            <Typography
              className="color-light"
              sx={{
                textTransform: "initial",
                fontSize: { xs: "16px", sm: "18px" },
                fontWeight: 500,
              }}
            >
              {" "}
              {copyButton}
            </Typography>
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ModalConferma;
